module.exports = __webpack_public_path__ + "images/marketing/peeps/john_serrantino.jpg";